<template>
  <div class="escolheComarcas">
    <div class="box-comarca">
      <div class="logo"></div>
      <alert-message />
      <div class="info active">
        <strong>Escolha as varas:</strong> <br /><br />
        Clique nas comarcas para abrir a listagem de varas.<br /><br />
        <strong>Obs.:</strong> Para cada inscrição, você só poderá selecionar varas de uma mesma
        comarca.
      </div>

      <div class="comarca-content" v-for="comarca in varas" v-bind:key="comarca.id_comarca">
        <div v-on:click="comarca.ativo = !comarca.ativo" class="comarca-toggle">
          <div class="icon-toggle">
            {{ comarca.ativo ? '-' : '+' }}
          </div>
          <div class="comarca-nome">
            {{ comarca.comarca }}
          </div>
        </div>
        <div :class="{ 'varas-content': true, active: comarca.ativo }">
          <div
            v-for="vara in comarca.varas"
            v-bind:key="vara.id_vara"
            :class="{ 'vara-box': true, active: vara.ativo }"
            style="display: grid; grid-template-columns: 1fr; grid-template-rows: 1fr"
          >
            <div
              class="check-option"
              style="padding: 20px; display: flex"
              v-on:click="validaVaras(vara)"
            >
              <div class="check"></div>
              <div class="description">
                {{ vara.nome_vara }}
              </div>
            </div>
            <div
              class="checkPlantonista"
              data-v-5d3ff9e0=""
              style="display: flex; gap: 10px; padding: 20px; background-color: white"
            >
              <!-- 
								ALTERAÇÃO 24/02/2026: Checkbox de plantonista agora é dinâmico
								- v-if="vara.plantonista": Exibe apenas se vara permite plantonista (PERMISSÃO no JSON)
								- :checked="vara.plantonista_selecionado": Controla estado do checkbox (SELEÇÃO do usuário)
								- vara.plantonista: propriedade do JSON (true/false) - NUNCA muda
								- vara.plantonista_selecionado: propriedade criada dinamicamente - muda ao clicar
							-->
              <div v-if="vara.plantonista" style="display: flex">
                <input
                  type="checkbox"
                  name="plantonista"
                  :checked="vara.plantonista_selecionado"
                  v-on:input="definePlantonistaNaVara(vara)"
                />
                <span>Plantonista</span>
              </div>
              <!-- 
                REGRA ANTIGA (até 25/02/2026):
                <div v-if="vara.juri" style="display: flex">
                
                ALTERAÇÃO 26/02/2026: Nova regra para VARA ÚNICA
                A opção de júri em "VARA ÚNICA" só deve aparecer quando a área escolhida for Criminal (tipo 3)
                Para outras varas, mantém a regra padrão (exibe se vara.juri === true)
                Usa método mostraOpcaoJuri() que aplica lógica condicional
              -->
              <div v-if="mostraOpcaoJuri(vara)" style="display: flex">
                <!-- verifica se exibe ou nao o juri -->
                <input
                  type="checkbox"
                  name="juri"
                  :checked="vara.juri_selecionado"
                  v-on:input="defineJuriNaVara(vara)"
                />
                <span>Júri</span>
              </div>
              <!-- 
                ALTERAÇÃO 24/02/2026: Mensagem de aviso para varas sem opção de plantonista ou júri
                Exibe mensagem em vermelho quando vara.plantonista === false E vara.juri === false
                
                ATUALIZAÇÃO 26/02/2026: Integrada com nova regra de VARA ÚNICA
                Agora usa mostraOpcaoJuri(vara) ao invés de vara.juri para verificar exibição EFETIVA
                Motivo: VARA ÚNICA pode ter juri:true no JSON mas não exibir (Cível/Família)
                Exemplo: VARA ÚNICA em Família → plantonista:false + mostraOpcaoJuri():false → Exibe mensagem ✅
              -->
              <div v-if="!vara.plantonista && !mostraOpcaoJuri(vara)" style="display: flex; margin-top: 5px">
                <small style="color: #dc3545; font-weight: 500">
                  Esta vara não possui opção de seleção como plantonista ou júri.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="button">
        <button v-on:click="confirmaDados()">Próximo</button>
      </div>
    </div>
  </div>
</template>

<script>
import AlertMessage from './components/AlertMessage.vue';
export default {
  name: 'escolhe-varas',
  components: { AlertMessage },
  data() {
    // console.log(this.$store.state.url_api + '/json/')
    return {
      url_varas: this.$store.state.url_api + '/json/',
      varas: {},
      aviso_teste: false,
      valida_token_url: this.$store.state.url_api + '/verificaTokenValido.php',
      selectedVara: [],
    };
  },
  methods: {
    definePlantonistaNaVara(vara) {
      console.log('ESTOU DENTRO DE DEFINEPLANTONISTANAVARA: ');
      console.log(vara);

      // CORREÇÃO 25/02/2026: Usa plantonista_selecionado para SELEÇÃO do usuário
      // vara.plantonista permanece intocado (PERMISSÃO do JSON)
      if (typeof vara.plantonista_selecionado === 'undefined') {
        this.$set(vara, 'plantonista_selecionado', false);
      }

      // Inverte apenas a SELEÇÃO (não a PERMISSÃO)
      vara.plantonista_selecionado = !vara.plantonista_selecionado;

      console.log('Plantonista selecionado:', vara.plantonista_selecionado);
      console.log('Plantonista permitido (permissão):', vara.plantonista);

      if (vara.plantonista_selecionado) {
        this.$store.commit('set_plantonista', true);
      } else {
        this.$store.commit('set_plantonista', false);
      }
    },

    defineJuriNaVara(vara) {
      console.log('ESTOU DENTRO DE DEFINEJURINAVARA: ');
      console.log(vara);

      // CORREÇÃO 25/02/2026: Usa juri_selecionado para SELEÇÃO do usuário
      // vara.juri permanece intocado (PERMISSÃO do JSON)
      if (typeof vara.juri_selecionado === 'undefined') {
        this.$set(vara, 'juri_selecionado', false);
      }

      // Inverte apenas a SELEÇÃO (não a PERMISSÃO)
      vara.juri_selecionado = !vara.juri_selecionado;

      console.log('Júri selecionado:', vara.juri_selecionado);
      console.log('Júri permitido (permissão):', vara.juri);
    },

    /**
     * ALTERAÇÃO 26/02/2026: Método para controlar exibição do checkbox de júri
     *
     * Regra especial para "VARA ÚNICA":
     * - Em "VARA ÚNICA", júri só aparece se a área escolhida for Criminal (tipo 3)
     * - Em outras varas, júri aparece normalmente se vara.juri === true
     *
     * @param {Object} vara - Objeto da vara com propriedades do JSON
     * @returns {Boolean} - true se deve exibir checkbox de júri, false caso contrário
     */
    mostraOpcaoJuri(vara) {
      // Se a vara não tem permissão de júri no JSON, não exibe
      if (!vara.juri) {
        console.log(`[mostraOpcaoJuri] Vara "${vara.nome_vara}" não tem júri no JSON`);
        return false;
      }

      // Normaliza o nome da vara para comparação
      const nomeVaraNormalizado = this.normalizarNome(vara.nome_vara);
      console.log(`[mostraOpcaoJuri] Nome normalizado: "${nomeVaraNormalizado}"`);

      // Verifica se é "VARA ÚNICA"
      if (nomeVaraNormalizado === 'VARA UNICA') {
        // Pega o tipo escolhido (área): 1=Cível, 2=Família, 3=Criminal
        const tipoEscolhido = this.$store.state.tipos_escolhidos[0];
        console.log(`[mostraOpcaoJuri] VARA ÚNICA detectada. Tipo escolhido: ${tipoEscolhido}`);

        // Júri em VARA ÚNICA só aparece se for Criminal (tipo 3)
        const mostraJuri = tipoEscolhido === 3;
        console.log(
          `[mostraOpcaoJuri] Resultado para VARA ÚNICA: ${mostraJuri ? 'EXIBE' : 'OCULTA'} júri`
        );
        return mostraJuri;
      }

      // Para outras varas, exibe normalmente se tem júri no JSON
      console.log(`[mostraOpcaoJuri] Vara "${vara.nome_vara}" - Exibe júri (não é VARA ÚNICA)`);
      return true;
    },

    /**
     * ALTERAÇÃO 26/02/2026: Helper para normalizar nome de vara
     * Remove acentos, converte para maiúsculas e remove espaços extras
     *
     * @param {String} nome - Nome da vara a ser normalizado
     * @returns {String} - Nome normalizado para comparação
     */
    normalizarNome(nome) {
      if (!nome) return '';

      return nome
        .toUpperCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Remove acentos
        .trim();
    },

    confirmaDados() {
      let comarca = this.varas.filter((x) => x.id_comarca == this.selectedVara[0].comarca)[0];
      comarca.varas = this.selectedVara;
      let comarcas = [];
      comarcas.push(comarca);

      this.$emit('loader', { active: true });
      this.$store.commit('set_varas', comarcas);

      // CORREÇÃO 25/02/2026: Removida lógica de variável global plantonista_juri
      // Cada vara agora controla suas próprias seleções (juri_selecionado, plantonista_selecionado)
      console.log('Varas selecionadas:', this.selectedVara);

      this.$router.push('/confirma-dados-inscricao');
    },
    validaVaras(vara) {
      const _self = this;
      const ativo = !vara.ativo;

      if (ativo) {
        if (_self.selectedVara.length == 0) {
          _self.selectedVara.push(vara);
          vara.ativo = !vara.ativo;
        } else {
          console.log(_self.selectedVara);
          if (_self.selectedVara[0].comarca == vara.comarca) {
            _self.selectedVara.push(vara);
            vara.ativo = !vara.ativo;
          } else {
            _self.$emit('alert_called', {
              message: 'Selecionar apenas varas de uma mesma comarca por inscrição.',
              type: 'danger',
            });
          }
        }
      } else {
        _self.selectedVara.splice(_self.selectedVara.indexOf(vara), 1);
        vara.ativo = !vara.ativo;
      }
    },
    verificaTokenValido(token) {
      return new Promise((resolve, reject) => {
        const Http = new XMLHttpRequest();
        const url = this.valida_token_url;

        let data = new FormData();
        data.append('token', token);

        Http.open('POST', url);
        Http.send(data);
        Http.onreadystatechange = (e) => {
          if (Http.readyState == 4 && Http.status == 200) {
            var res = Http.responseText;
            res = JSON.parse(res);
            if (res.mode) {
              if (res.mode === 'sandbox') {
                this.aviso_teste = true;
              }
            }
            if (res.tokenValido) {
              resolve(true);
            } else {
              resolve(false);
            }
          }
        };
      });
    },
  },
  beforeMount() {
    const _self = this;
    this.$emit('loader', { active: true });

    if (sessionStorage.token) {
      this.verificaTokenValido(sessionStorage.getItem('token')).then((verificaToken) => {
        if (!verificaToken) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('varas');
          sessionStorage.removeItem('tipos_escolhidos');
          _self.$emit('alert_called', { message: 'Token de sessão inválido!', type: 'danger' });
          _self.$router.push('/');
        }
      });
    } else {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('varas');
      sessionStorage.removeItem('tipos_escolhidos');
      _self.$emit('alert_called', { message: 'Token de sessão inválido!', type: 'danger' });
      this.$router.push('/');
    }

    _self.$store.commit('get_storage');

    //busca varas com os tipos escolhidos
    const Http = new XMLHttpRequest();
    let url = this.url_varas;

    var data = new FormData();
    data.append('tipos_filter', this.$store.state.tipos_escolhidos);

    const tipoVaraEscolhida = {
      1: 'civil',
      2: 'familia',
      3: 'criminal',
      4: 'juri',
      5: 'eleitoral',
    };
    if (this.$store.state.tipos_escolhidos == '') {
      //ESSA BUDEGA AQUI SÓ SERVE PARA CEJUSC, LEMBRA DISSO ANO QUE VEM QUANDO EU NÃO TIVER AQUI JOANA
      this.$store.state.tipos_escolhidos = [1];
    }
    url += tipoVaraEscolhida[this.$store.state.tipos_escolhidos[0]] + '.json';

    Http.open('POST', url);
    Http.send(data);
    Http.onreadystatechange = (e) => {
      if (Http.readyState == 4 && Http.status == 200) {
        var res = Http.responseText;
        res = JSON.parse(res);

        /* 
          ALTERAÇÃO 24/02/2026: Ordenação alfabética das comarcas
          Ordena o array de comarcas por ordem alfabética usando o campo 'comarca'
          Utiliza localeCompare com locale 'pt-BR' para respeitar acentuação e caracteres especiais
        */
        res.sort((a, b) => {
          return a.comarca.localeCompare(b.comarca, 'pt-BR', { sensitivity: 'base' });
        });

        _self.varas = res;

        if (sessionStorage.varas) {
          let comarca_sessao = sessionStorage.getItem('varas');

          const comarcas = JSON.parse(comarca_sessao);
          const comarca = comarcas[0];

          const idxComarca = _self.varas.findIndex((vara) => vara.id_comarca == comarca.id_comarca);
          _self.selectedVara = comarca.varas;

          this.varas[idxComarca].ativo = true;

          this.varas[idxComarca].varas = this.varas[idxComarca].varas.map((vara) => {
            if (
              this.selectedVara.findIndex((selectVara) => vara.id_vara === selectVara.id_vara) !==
              -1
            ) {
              vara.ativo = true;
            }
            return vara;
          });
        }
        this.$emit('loader', { active: false });
      }
    };
  },
};
</script>
<style lang="scss" scoped>
.escolheComarcas {
  background-image: url('https://advogadosoab.arcoinformatica.com.br/view/public/img/bkg-vitoria.jpg');
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  // overflow-y: auto;

  @media (max-width: 480px) {
    .box-comarca {
      width: 100% !important;
      height: 100% !important;
      max-height: calc(100% - 60px);
      padding-left: 15px !important;
      padding-right: 15px !important;
    }
  }

  @media (max-width: 768px) {
    .box-comarca {
      width: 60%;
    }
  }

  @media (min-width: 768px) {
    .box-comarca {
      width: 600px;
      max-height: calc(90% - 60px);
    }
  }

  .box-comarca {
    background-color: white;
    padding: 50px;
    box-shadow: 0 0 30px #717171;
    overflow-y: auto;

    &::before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      z-index: -1;
      pointer-events: none;
      margin: 0;
    }

    .logo {
      background-image: url('https://www.oabes.org.br/img/logo/logo.png');
      width: 100%;
      padding-bottom: 15%;
      background-size: contain;
      background-position: left;
      background-repeat: no-repeat;
    }

    .info {
      font-size: 14px;
      text-align: left;
      width: 100%;
      padding-top: 30px;
      display: none;

      .info-senha {
        span {
          color: #737373;
          line-height: 20px;
        }
      }

      &.active {
        display: block;
      }
    }

    .button {
      margin-top: 30px;
      width: 100%;
      display: flex;
      justify-content: flex-end;

      button {
        padding: 10px 30px;
        border: 0;
        background-color: #357a9b;
        color: white;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          background-color: #0a435f;
          transition: 0.3s all ease-in-out;
        }
      }
    }

    .comarca-content {
      width: 100;
      margin-top: 15px;
    }

    .comarca-content {
      margin-bottom: 15px;
      box-shadow: 0px 2px 2px #d8d8d8;
      background-color: #f8f8f8;
      padding: 10px;

      .comarca-toggle {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        transition: 0.3s ease-in-out all;

        &:hover {
          background-color: #f8f8f8;

          .comarca-nome {
            color: #c83827;
          }
        }

        .icon-toggle {
          font-weight: 400;
          font-size: 40px;
          color: #c83827;
          margin-right: 15px;
          transition: 0.3s all ease-in-out;
        }

        .comarca-nome {
          color: #222c45;
          font-weight: bold;
          transition: 0.3s ease-in-out all;
        }
      }
    }

    .varas-content {
      width: auto;
      padding-left: 30px;
      padding-right: 15px;
      height: 0;
      overflow: hidden;
      opacity: 0;
      pointer-events: none;
      transition: 0.5s all ease-in-out;

      &.active {
        height: auto !important;
        opacity: 1 !important;
        pointer-events: all;
      }

      .vara-box {
        width: auto;
        padding: 10px;
        background-color: #eee;
        border-bottom: solid 1.3px #dadada;
        border-right: solid 1.3px #dadada;
        margin-bottom: 10px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        transition: 0.1s ease-in-out all;

        .checkPlantonista {
          display: none !important;
        }

        &.active {
          background-color: #43a047;
          .checkPlantonista {
            display: flex !important;
          }
          .description {
            color: white;
          }

          .check {
            border-color: white;

            &::after {
              content: '\2713';
              position: absolute;
              top: -50%;
              left: 50%;
              bottom: 0;
              right: 0;
              width: 100%;
              height: 100%;
              font-size: 53px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #183e00;
            }
          }
        }

        .check {
          width: 17px;
          height: 17px;
          border: solid 3px #929292;
          border-radius: 3px;
          margin-right: 15px;
          position: relative;
          flex-basis: auto;
        }

        .description {
          text-transform: uppercase;
          font-weight: bold;
          font-size: 14px;
          color: #565656;
          flex-basis: fit-content;
        }
      }
    }
  }
}

.comarca-wrapper {
  float: left;
  width: 100%;
}
</style>
